const CONSTANTS = {
  INVALID_OAUTH_TOKEN: "Invalid oauth token",
  OUT_OF_CLAIMS_MESSAGE:
    "You’ve used up all of your benefits. To pay for today’s service, choose from the options below.",
  MEMBER_NOT_FOUND_MESSAGE: "It looks as though you haven't signed up for roadside benefits yet. You can continue by paying for today's service",
  MEMBER_NOT_FOUND_MESSAGE_ALLSTATE_PARTNER:
    "It looks as though you haven't signed up for roadside benefits yet. You can either pay for just today's service, or call us to ask about a membership.",
  GHR_PROMOTION_MESSAGE_KEY: "GHR_PROMOTION_MESSAGE_KEY",
  MEMBER_NOT_UNIQUELY_FOUND_MESSAGE:
    "We're unable to find your benefits information.",
  OUT_OF_CLAIMS: "OutOfClaims",
  INVALID_MVA_NUMBER: "Invalid MVA Number",
  MEMBER_NOT_FOUND: "memberNotFound",
  JACADA_AUTHENTICATION_MESSAGE: "JacadaRequestSent authenticated set to Y",
  JACADA_RESPONSE_FAILURE_MESSAGE:
    "JacadaResponseReceived No response from Jacada or API failed",
  MUST_CALL_FOR_WEIGHT_CLASS: "MUST_CALL_FOR_WEIGHT_CLASS",
  MUST_SHOW_NO_BENEFITS_PRICING_INFO: "MUST_SHOW_NO_BENEFITS_PRICING_INFO",
  WAIT_PERIOD:
    "Your membership is not yet eligible for roadside coverage due to a 72-hour waiting period. To pay for today's service, choose from the options below.",
  MUST_DISPLAY_TRIAGE_STEPS: "MUST_DISPLAY_TRIAGE_STEPS",
  NO_MEMBER_FOUND: "NOMEM",
  MUTLIPLE_MEMBERS_FOUND: "MULTIMEMBER",
  INACTIVE: "INACTIVE",
  AUTO_PHONE_LOOKUP: "autoPhoneLookup",
  PHONE_NUMBER_LAST_NAME_LOOKUP: "phoneNumberLastNameLookup",
  PHONE_LOOKUP: "phoneLookup",
  PHONE_NUMBER: "phoneNumber",
  MOTOR_NUMBER_LOOKUP: "motorNumberLookup",
  RENTAL_AGREEMENT_LOOKUP: "rentalAgreementLookup",
  PHONE_NUMBER_LAST_NAME_TRANSACTION_NUMBER_LOOKUP: "phoneNumberLastNameTransactionNumberLookup",
  TRANSACTION_NUMBER_LOOKUP: "transactionNumberLookup",
  ACTIVE: "ACTIVE",
  SERVICE_REQUEST_DENIED: "serviceRequestDenied",
  FIRST_NAME_LAST_NAME_COMPANY: "firstNameLastNameCompany",

  NO_CLAIMS_LEFT: 0,
  HTML_CLASS: {
    DISABLED: "is-disabled",
    ERROR: "has-error",
    WARNING: "has-warning",
    ACTIVE: "is-active",
    FOCUS: "has-focus",
  },

  KEY_CODES: {
    ENTER: 13,
    ESCAPE: 27,
    LEFT: 37,
    RIGHT: 38,
    UP: 39,
    DOWN: 40,
  },

  DELETE: 46,
  BACKSPACE: 8,
  EXPONENTIAL: 69,
  DECIMALPOINT: 190,

  DEFAULT_DATE_FORMAT: "MM/DD/YYYY",

  MONTHS: [
    ["January", "Jan"],
    ["February", "Feb"],
    ["March", "Mar"],
    ["April", "Apr"],
    ["May", "May"],
    ["June", "Jun"],
    ["July", "Jul"],
    ["August", "Aug"],
    ["September", "Sept"],
    ["October", "Oct"],
    ["November", "Nov"],
    ["December", "Dec"],
  ],

  MONTHS_IN_A_YEAR: 12,
  DAYS_IN_A_WEEK: 7,
  MILLISECONDS_IN_ONE_DAY: 1000 * 60 * 60 * 24,

  DAYS: [
    ["Sunday", "Sun", "S"],
    ["Monday", "Mon", "M"],
    ["Tuesday", "Tue", "T"],
    ["Wednesday", "Wed", "W"],
    ["Thursday", "Thur", "T"],
    ["Friday", "Fri", "F"],
    ["Saturday", "Sat", "S"],
  ],

  ALLSTATE_HOST: "roadside.allstate.com",
  VANITY_HOST: "www.getroadsideassistance.com",
  MANAGE_ROADSIDE_URL: "https://manageroadside.allstate.com/login",
  QA_MANAGE_ROADSIDE_URL: "https://manageroadside-test.allstate.com/login",
  SERVICE_STATUS_COVERED: "Covered",
  SERVICE_STATUS_NOT_COVERED: "Not Covered",
};

export default CONSTANTS;

export const CANADA = "CA";
export const UNITED_STATES = "US";
export const PUERTO_RICO = "PR";

/** PARTNER CODE START */
export const AAR = "AAR";
export const AMC = "AMC";
export const C74 = "C74";
export const D24 = "D24";
export const ETL = "ETL";
export const JJ = "JJ";
export const PCE = "PCE";
export const PEP = "PEP";
export const PLD = "PLD";

/** Emkay */
export const EMKAY_PARTNER_CODES = ["ERU", "EMS", "ERC", "ESC"];

/** Verizon */
export const VZW = "VZW";

/** Walmart */
export const WRD = "WRD";

/** Emkay partner ERU */
export const ERU = "ERU";

/** VAS */
export const V15 = "V15";

/** Avis */
export const CRA = "CRA", PCR = "PCR", BCA = "BCA";
/** PARTNER CODE END */

export const PPU_GHR_APP_ID = "2757";

export const NEW_JOB = "NEW JOB";
export const NEW_JOB_RSV = "NEW_JOB";
export const DROP_PASSG = "DROP_PASSG";
export const COMPLETED = "COMPLETED";
export const GONE_ON_ARRIVAL = "GOA REQ";
export const GONE_ON_ARRIVAL_RSV = "GOA_REQ";
export const CANCELLED = "CANCELLED";
export const CANCELED = "CANCELED";
export const BOOKED = "BOOKED";
export const ASSIGNED = "ASSIGNED";
export const CSR_TAKEOVER = "CSR TAKE OVER";
export const EN_ROUTE = "EN-ROUTE";
export const GPS = "GPS";
export const APPROACHING = "APPROACHING";
export const ONSITE = "ONSITE";
export const ARRIVED_ONSITE = "ARRIVED ONSITE";
export const ARRIVED_ONSITE_RSV = "ARRIVED_ONSITE";
export const LOADED = "LOADED";
export const EN_ROUTE_DROP = "EN-ROUTE DROP";
export const EN_ROUTE_DROP_RSV = "EN-ROUTE_DROP";
export const DROP_LOCATION = "DROP LOCATION";
export const DROP_LOCATION_RSV = "DROP_LOCATION";
export const DROP_SIGN = "DROP SIGN";
export const DROP_SIGN_RSV = "DROP_SIGN";

export const ACTIVE_RESCUE_STATUSES = [
  BOOKED,
  ASSIGNED,
  CSR_TAKEOVER,
  EN_ROUTE,
  APPROACHING,
  GPS,
  ONSITE,
  ARRIVED_ONSITE_RSV,
  LOADED,
  DROP_SIGN_RSV,
  DROP_LOCATION_RSV,
  GONE_ON_ARRIVAL_RSV,
  COMPLETED,
];

export const TOW = "Tow";
export const TOW_DISTANCE_APPROVAL_LIMIT_MILES = 50;
export const FUEL_DELIVERY = "Fuel Delivery";
export const GAS = "Gas";
export const JUMP_START = "Jump Start";
export const START = "Start";
export const LOCKOUT = "Lockout";
export const TIRE_CHANGE = "Tire Change";
export const supportedColors = [
  { text: "Black", value: "BLACK" },
  { text: "Blue", value: "BLUE" },
  { text: "Brown", value: "BROWN" },
  { text: "Burgundy", value: "BURGUNDY" },
  { text: "Gold", value: "GOLD" },
  { text: "Green", value: "GREEN" },
  { text: "Grey", value: "GREY" },
  { text: "Orange", value: "ORANGE" },
  { text: "Purple", value: "PURPLE" },
  { text: "Red", value: "RED" },
  { text: "Silver", value: "SILVER" },
  { text: "White", value: "WHITE" },
  { text: "Yellow", value: "YELLOW" },
];

export const ZIP_LENGTH_REGEX = /^\d{5}(-\d{4})?$/;
export const ETL_POLICY_NUMBER_REGEX = /([A-Z]{4})+(\d{9})/;

export const hasSpecialChars = /[\W]|[`~!@?$%^&*()_+=<>\]\\[\\{};:'"|\\/]/;
export const isOnlyNumbers = /^\d+$/;
export const isOnlyAlpha = /^[A-Za-z]+$/i;

export const JACADA_PROD_URL =
  "https://as-analytics.gointeract.io/conversations";
export const JACADA_DEV_URL =
  "https://as-analytics.gointeract.io/conversations";
export const API_COMBO = "9JxqyeBSNk94HYl4zrHBT60KCAzs170b2JvaY7eP";

// Parallel "converse" (intent-firing) endpoints to Jacada/Uniphore's
// gointeract.io voiceConnector, keyed by Amazon Connect's contactId instead
// of Jacada's conversationId. Routed through wle-proxy's `/api/voice/...`
// (see createAwsConnectIntent.ts) rather than called directly.
export const AWS_CONNECT_TENANT_ID = "allstate";
// `arsAction` value sent on the final intent of a Rescue Tracker session,
// signaling wle-proxy/drw-proxy to tear down the Amazon Connect chat.
export const AWS_CONNECT_ARS_ACTION_DISCONNECT = "disconnect";
// The intent (fired on load of the Rescue Tracker "Track Your Rescue"/done
// page - see public/scripts/appConfig.js `pages.done.intents`) that marks
// the final submission of a Rescue Tracker session, triggering disconnect.
export const AWS_CONNECT_DISCONNECT_INTENT_TEXT = "VO Rescue Confirmation";

export const DD_PROD_ENV = "0418000019QP - Roadside";
export const DD_PROD_ID = "16d8dc99-e708-49fb-80fb-1da0837875f7";
export const DD_PROD_TOKEN = "pubf7ade4f3be1308963c5b8312e3e5e3c6";

export const DD_QA_ENV = "0418000019QP - QA Roadside";
export const DD_QA_ID = "5f201f28-b926-48ef-a119-b052abab9a3e";
export const DD_QA_TOKEN = "pub1fffb43ae32c9a41de9c46b333e624ba";

export const TOW_SERVICE_ID = 1;
export const FUEL_SERVICE_ID = 3;
export const TIRE_CHANGE_ID = 4;
export const BATTERY_SERVICE_ID = 5;

export const NO = "N";
export const YES = "Y";

export const PPU = "ppu";
export const OMNI_ASSIST = "OmniAssist";

export const SERVICE_LIMIT = "service-limit";
export const SERVICE_UNAVAILABLE = "service-unavailable";
export const VEHICLE_NOT_FOUND = "vehicle-not-found";


export type LocaleCodes = typeof en_US | typeof en_CA | typeof es_US | typeof fr_CA | typeof en_PR | typeof es_PR;
export const en_US = "en_US";
export const en_CA = "en_CA";
export const es_US = "es_US";
export const fr_CA = "fr_CA";
export const en_PR = "en_PR"; // English PEP Puerto Rico support
export const es_PR = "es_PR"; // Spanish PEP Puerto Rico support
export const SUPPORTED_LANGUAGES = [en_US, en_CA, fr_CA, es_US, en_PR, es_PR];

export const USA_COUNTRY_CODE = "USA";
export const CANADA_COUNTRY_CODE = "CAN";
export const GALLON = "gallon";
export const LITER = "liter";
export const FRIENDS_FAMILY_VERSION = "f"; // RT SMS
export const RESCUE_CUSTOMER_VERSION = "l"; // RT SMS
export const RESCUE_WLEB = "wleb"; // RT WLE
export const RESCUE_WLEOA = "wleoa"; // RT WLE
export const RESCUE_WLEM = "wlem"; // RT WLE
export const RESCUE_WLEP = "wlep"; // RT WLE
export const SURCHARGE = "surcharge";

export const RESCUE_WLES = [
  RESCUE_WLEB,
  RESCUE_WLEOA,
  RESCUE_WLEM,
  RESCUE_WLEP,
];

export const BENEFITS = "benefits";
export const MEMBER = "member";

export const DEFAULT_OPENFROM = "08:00";
export const DEFAULT_CLOSEAT = "17:00";

export const SUSPENDED_VEHICLE_TO_CALL_CENTER =
  "SUSPENDED_VEHICLE_TO_CALL_CENTER";

export const DISPLAY_TRIAGE_STEPS_STATUSES = [
  CONSTANTS.MUST_DISPLAY_TRIAGE_STEPS,
  CONSTANTS.MUST_SHOW_NO_BENEFITS_PRICING_INFO,
];

export const ACTIVE_MEMBERSHIP_STATUSES = [
  CONSTANTS.MUST_DISPLAY_TRIAGE_STEPS,
  CONSTANTS.MUST_SHOW_NO_BENEFITS_PRICING_INFO,
  CONSTANTS.ACTIVE,
];

export const MATCH_FAILURE = "MATCH_FAILURE";
export const MEMBER_NOT_FOUND_STATUS = "MEMBER_NOT_FOUND";
export const MULTIPLE_MEMBERS_RETURNED = "MULTIPLE_MEMBERS_RETURNED";
export const MUTLIPLE_MEMBERS_FOUND = "MUTLIPLE_MEMBERS_FOUND";

export const DISPATCH_GUARANTEE = "DISPATCH_GUARANTEE";
export const MEMBER_NOT_FOUND_VAS = "MEMBER_NOT_FOUND_VAS";
export const WAIT_PERIOD_STATUS = "WAITPERIOD";

export const EPCS_SCRIPT_ID = "epcs_script";

export const EPCS_STATUS_SUCCESS = "SUCCESS";
export const EPCS_STATUS_FATAL = "FATAL";
export const EPCS_STATUS_CARD_ERROR = "CARD_ERROR";

export const CONTRACT_CANCELLED = "CONTRACT CANCELLED";
export const CONTRACT_EXPIRED = "CONTRACT EXPIRED";
export const CONTRACT_NOT_ACTIVE_YET = "CONTRACT NOT ACTIVE YET";
export const INACTIVE = "INACTIVE";
export const BENEFITS_USED_UP = "BENEFITS_USED_UP";
export const REIMBURSEMENT = "REIMBURSEMENT";
export const MEMBER_NUMBER_VIN = "MemberNumberVin";
export const LAST_NAME_STATE_ZIP = "LastNameStateZip";
export const GHR_HOLIDAY_PROMO_CODE = "010160011";

export const NOT_COVERED_PPU_STATUSES = [
  CONTRACT_CANCELLED,
  CONTRACT_EXPIRED,
  CONTRACT_NOT_ACTIVE_YET,
  INACTIVE,
  BENEFITS_USED_UP,
  REIMBURSEMENT,
  WAIT_PERIOD_STATUS,
  MATCH_FAILURE
];

export const NOT_COVERED_REASONS = [
  {
    id: CONTRACT_CANCELLED,
    reason:
      "Your coverage  was cancelled but we can still help. Use our pay-per-use option to get roadside help today.",
  },
  {
    id: CONTRACT_EXPIRED,
    reason:
      "Your coverage is expired but we can still help. Use our pay-per-use option to get roadside help today.",
  },
  {
    id: CONTRACT_NOT_ACTIVE_YET,
    reason:
      "Your coverage is not active yet but we can still help. Use our pay-per-use options to get roadside help today.",
  },
  {
    id: INACTIVE,
    reason:
      "Your coverage is not active yet but we can still help. Use our pay-per-use options to get roadside help today.",
  },
  {
    id: BENEFITS_USED_UP,
    reason:
      "You’ve used up all of your benefits. To pay for today’s service, choose from the options below.",
  },
  {
    id: CONSTANTS.MUST_CALL_FOR_WEIGHT_CLASS,
    reason:
      "You’ve used up all of your benefits. To pay for today’s service, choose from the options below.",
  },
  {
    id: REIMBURSEMENT,
    reason:
      "Your coverage requires you to prepay for your roadside service and submit a claim for reimbursement.",
  },
  {
    id: WAIT_PERIOD_STATUS,
    reason:
      "Your membership is not yet eligible for roadside coverage due to a 72-hour waiting period. To pay for today's service, choose from the options below."
  },
  {
    id: MATCH_FAILURE,
    reason:
      "It looks as though you haven't signed up for roadside benefits yet. You can either pay for just today's service, or call us to ask about a membership."
  }
];

export const AMAZON_CONNNECT_ID = "amazon_connect";

export const AMAZON_CONNECT_CHAT_USER_TYPE = "Customer";

export const UNSUPPORTED_EQUIPMENT_CLASSES = ["medium", "heavy"];

export const LAST_NAME_AUTHENTICATION_CHECK_PARTNERS = ["AMC", "JJ", "AAR"];
export const JJ_AND_AMC = ["AMC", "JJ"];

export const LAST_NAME_AUTHENTICATION_CHECK_LOOKUP_TYPES = [
  "memberNumberLastNameLookup",
  "policyNumberLastNameLookup",
  "phoneNumberLastNameLookup"
];

export const PHONE_LOOKUP_TYPE = [
 "phoneNumber",
  "phoneLookup",
  "autoPhoneLookup"
]

export const STACK_TYPE_NOT_STACKED = "1436";
export const STACK_TYPE_COMBINED = "1437";
export const STACK_TYPE_RENTED_OR_BORROWED = "1438";
export const TIRE_STANDARD_WITHOUT_SPARE = "tire_standard_without_spare";
export const MECHANICAL_KEY = "mechanical_key";
export const VANDALISM = "vandalism";
export const BATTERY = "battery";
export const ACCIDENT = "accident";
export const PAYLOAD_NEW = "payload_new";
export const TRIAGE_TYPE = "triage_type"
export const SERVICE_CHANGE_ORIGIN = "serviceChangeOrigin";
export const CHANGE_TIRE = "Changetire";
export const TIRE_DAMAGE = "tire_damage";

export const MECHANICAL_ELECTRIC_PROBLEM = "mechanical_electric_problem";

export const ABG_TRANSPORTATION_COMMENT = "Customer needs help with transportation.";
export const ABG_REPLACEMENT_CAR_COMMENT = "Customer needs replacement vehicle.";
export const ABG_NO_DESTINATION_NOTE_FOR_RA = "Action Required: Set up tow destination address"

export const ENGINE_DOES_NOT_START = "engine_does_not_start"

export const validCustomerType = (customerType: string) =>
  !["uber", "lyft", "via"].includes(customerType);

export const MEMBER_NOT_FOUND_ERROR_MESSAGES = [
  CONSTANTS.MEMBER_NOT_FOUND,
  CONSTANTS.MEMBER_NOT_FOUND_MESSAGE,
  CONSTANTS.MEMBER_NOT_FOUND_MESSAGE_ALLSTATE_PARTNER,
];

export const SERVICE_TRANSITION_EXCLUDED_LOOKUP_TYPES = [
  CONSTANTS.AUTO_PHONE_LOOKUP,
  CONSTANTS.PHONE_NUMBER_LAST_NAME_LOOKUP,
  CONSTANTS.TRANSACTION_NUMBER_LOOKUP,
];

export const FERRARI = "FERRARI";

export const STANDARD = "Standard";
export const ENHANCED = "Enhanced";
export const TOW_TO_LOCATION_TYPE_124 = 124;